// Generated by ReScript, PLEASE EDIT WITH CARE


function classifyFromUrlParams(componentName, surfaceFamily) {
  if (componentName !== "paymentMethodsSDK") {
    return "OtherFamily";
  }
  if (surfaceFamily === undefined) {
    return "OtherFamily";
  }
  switch (surfaceFamily) {
    case "payments" :
      return "PaymentsFamily";
    case "vault" :
      return "VaultFamily";
    default:
      return "OtherFamily";
  }
}

function classifyCoordinatorFromUrl(componentName, surfaceFamily) {
  if (componentName !== "cardFormCoordinator") {
    return "OtherCoordinatorFamily";
  }
  if (surfaceFamily === undefined) {
    return "OtherCoordinatorFamily";
  }
  switch (surfaceFamily) {
    case "payments" :
      return "PaymentsCoordinator";
    case "vault" :
      return "VaultCoordinator";
    default:
      return "OtherCoordinatorFamily";
  }
}

export {
  classifyFromUrlParams,
  classifyCoordinatorFromUrl,
}
/* No side effect */
